import React from 'react';
import School, { SchoolInput } from '../../models/School';
import Pagination from '../../models/Pagination';

import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';

import ColoredTableRow from '../ColoredTableRow';
import PaginationButtons from '../PaginationButtons';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconButton: {
      padding: 5
    },
    paper: {
      marginBottom: 64 + theme.spacing(4)
    },
    progress: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(3),
      textAlign: 'center'
    },
    statusCell: {
      textAlign: 'center'
    }
  }),
);

export interface Row {
  data: (School|SchoolInput);
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  showEditButton?: boolean;
  onClickEdit?: (row: Row, index: number) => void;
  pagination?: Pagination;
  onChangePage?: (page: number) => void;
  showInfoButton?: boolean;
  onClickInfo?: (row: Row, index: number) => void;
}

const SchoolListTable: React.FC<Props> = (props) => {  
  const classes = useStyles();
  const showEditButton = props.showEditButton || false;
  const showInfoButton = props.showInfoButton || false;

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  return (
    <Paper square className={classes.paper}>
      <Table size="small">
        <TableHead>
          <TableRow selected={true}>
            <TableCell>RUEE</TableCell>
            <TableCell>Departamento</TableCell>
            <TableCell>Número</TableCell>
            <TableCell>Área</TableCell>
            <TableCell>Zona geográfica</TableCell>
            <TableCell>Categoría</TableCell>
            <TableCell>Turno</TableCell>
            <TableCell>Horario</TableCell>
            <TableCell>Nombre</TableCell>
            <TableCell>Calle</TableCell>
            <TableCell>Altura</TableCell>
            <TableCell>Localidad</TableCell>
            <TableCell>Teléfono</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Comparte</TableCell>
            { showEditButton && <TableCell/> }
            { showInfoButton && <TableCell/> }
          </TableRow>
        </TableHead>
        <TableBody>
          {props.rows.map((row, index) =>
            <ColoredTableRow key={index} color={mapActionToColor(row.action)}>
              <TableCell>{row.data.rue}</TableCell>
              <TableCell>{row.data.department}</TableCell>
              <TableCell>Nro. {row.data.number}</TableCell>
              <TableCell>{row.data.area}</TableCell>
              <TableCell>{row.data.zone}</TableCell>
              <TableCell>{row.data.category}</TableCell>
              <TableCell>{row.data.shiftName}</TableCell>
              <TableCell>{row.data.shiftTimes}</TableCell>
              <TableCell>{row.data.name}</TableCell>
              <TableCell>{row.data.streetName}</TableCell>
              <TableCell>{row.data.streetNumber}</TableCell>
              <TableCell>{row.data.locality}</TableCell>
              <TableCell>{(row.data as School).fullPhoneNumber || row.data.phoneNumber}</TableCell>
              <TableCell>{row.data.email}</TableCell>
              <TableCell>{row.data.share}</TableCell>
              { showEditButton &&
                <TableCell>
                  <IconButton
                    size="small"
                    className={classes.iconButton}
                    onClick={() => props.onClickEdit && props.onClickEdit(row, index)}
                  >
                    <EditIcon fontSize="inherit" />
                  </IconButton>
                </TableCell>
              }
              { showInfoButton &&
                <TableCell>
                  <IconButton
                    size="small"
                    className={classes.iconButton}
                    onClick={() => props.onClickInfo && props.onClickInfo(row, index)}
                  >
                    <InfoIcon fontSize="inherit" />
                  </IconButton>
                </TableCell>
              }
            </ColoredTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div className={classes.progress}>
          <CircularProgress size={100} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default SchoolListTable